import { formatMoney } from "//flarespace.com/cdn/shop/t/53/assets/theme.js?v=64222155022109567771767730062";

const currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

class LgBundleNav extends HTMLElement {
  constructor () {
    super();
    this.bundleSelectionStep = parseInt(this.getAttribute('bundle-selection-step'))

    this.navItems = this.querySelectorAll('.js-nav')

    this.currentStep = 1
  }

  connectedCallback () {
    this.stepUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.stepUpdate, this.updateStep.bind(this));
    this.navItems.forEach(navItem => navItem.addEventListener('click', this.handleNav.bind(this)))
  }

  disconnectedCallback () {
    if (this.stepUpdateUnsubscriber) {
      this.stepUpdateUnsubscriber();
    }
  }

  updateStep (data) {
    if (this.currentStep === data.step) return;

    this.currentStep = data.step;

    this.navItems.forEach(navItem => {
      navItem.classList[this.currentStep === +navItem.dataset.step ? 'add' : 'remove']('active')
    })
  }

  handleNav (e) {
    const { step } = e.target.dataset

    if (this.currentStep === +step) return;

    this.currentStep = +step;

    this.navItems.forEach(item => {
      item.classList[+item.dataset.step === +step ? 'add' : 'remove']('active')
    })

    publish(PUB_SUB_EVENTS.stepUpdate, { step: +step })
  }
}

customElements.define('lg-bundle-nav', LgBundleNav)

class LgBundleSteps extends HTMLElement {
  constructor () {
    super();
    this.currentStep = 1

    this.stepItems = this.querySelectorAll('.js-bundle-step')
    this.navButtons = this.querySelectorAll('.js-nav-btn')
  }

  connectedCallback () {
    this.stepUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.stepUpdate, this.updateStep.bind(this));
    this.selectionUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, this.updatePriceDisplay.bind(this));

    this.navButtons.forEach(btn => btn.addEventListener('click', this.handleNav.bind(this)))
  }

  disconnectedCallback () {
    if (this.stepUpdateUnsubscriber) {
      this.stepUpdateUnsubscriber();
    }

    if (this.selectionUpdateUnsubscriber) {
      this.selectionUpdateUnsubscriber();
    }
  }

  handleNav (event) {
    this.updateStep({
      step: parseInt(event.target.dataset.step)
    })
  }

  updateStep (data) {
    if (this.currentStep === data.step) return;

    this.currentStep = data.step;

    publish(PUB_SUB_EVENTS.stepUpdate, {
      step: data.step
    })

    this.stepItems.forEach(item => {
      if (+item.dataset.step === this.currentStep) {
        item.classList.remove('hidden');
        setTimeout(() => item.classList.add('active'))
      } else {
        item.classList.remove('active');
        setTimeout(() => item.classList.add('hidden'))
      }
    })
  }

  updatePriceDisplay () {
    const mainVariantIds = [... new Set(Array.from(this.querySelectorAll('.js-main-variant')).map(el => +el.value))]

    const subVariantIds = [...new Set(Array.from(this.querySelectorAll('.js-dependent-variants:not(.hidden)'))
      .map(el => +el.querySelector('.js-dependent-variant:checked')?.value))];

    const variants = window.bundles.products.filter(variant => [...mainVariantIds, ...subVariantIds].includes(variant.id))
      .filter(variant => variant.add_to_cart)

    const price = variants.map(variant => variant.price).reduce((a, b) => a + b, 0)
    const compare_at_price = variants.map(variant => variant.compare_at_price || variant.price).reduce((a, b) => a + b, 0)

    this.querySelector('.js-product-prices compare-at-price').classList[compare_at_price === price ? 'add' : 'remove']('hidden')
    this.querySelector('.js-product-prices [data-save-price]').style.display = compare_at_price === price ? 'none' : ''
    this.querySelector('.js-product-prices').classList[price === compare_at_price ? 'remove' : 'add']('text-on-sale')

    this.querySelector('.js-product-prices [data-compare-price]').innerHTML = formatMoney(compare_at_price, currencyFormat)
    this.querySelector('.js-product-prices [data-product-price]').innerHTML = formatMoney(price, currencyFormat)
    this.querySelector('.js-product-prices [data-save-price]').innerHTML = `Save ${formatMoney(compare_at_price - price, currencyFormat)}`
  }
}

customElements.define('lg-bundle-steps', LgBundleSteps)

class LgBundleSelection extends HTMLElement {
  constructor () {
    super();
    this.bundleSelectionStep = parseInt(this.getAttribute('bundle-selection-step'))

    this.submitBtn = this.querySelector('.js-selection-confirm')
    this.mainVariantsWrapper = this.querySelector('.js-main-variants')
    this.mainVariantSelection = this.querySelector('.js-main-variant')
    this.subVariantsWrappers = this.querySelectorAll('.js-dependent-variants')

    this.selectionLabel = this.dataset.selectionLabel
    this.stepSize = parseInt(this.dataset.stepSize)
    this.selectionStep = parseInt(this.dataset.selectionStep)

    this.filter = this.mainVariantsWrapper?.dataset.filter
    this.mainProductId = this.mainVariantsWrapper?.dataset?.productId
    this.mainVariantId = this.mainVariantSelection?.value;

    if (!!this.mainVariantSelection) {
      this.validateOptions()
      this.querySelector('form').addEventListener('variant:change', this.handleMainSelection.bind(this))
    }

    this.querySelectorAll('.js-dependent-variant').forEach(el => el.addEventListener('input', this.handleSubVariantSelection.bind(this)))
  }

  connectedCallback () {
    this.stepUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.stepUpdate, this.updateStep.bind(this));
    this.selectionUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, this.renderSelections.bind(this));
    this.submitBtn.addEventListener('click', this.handleSubmit.bind(this));

    this.handlePriceDisplay()

    const observer = new MutationObserver(([mutation]) =>{
      if (mutation.target.classList.contains('active')) {
        this.updateSlideshow();
        this.handlePriceDisplay();
      }
    });

    observer.observe(this, {
      attributes: true,
      attributeFilter: ['class']
    })
  }

  disconnectedCallback () {
    if (this.stepUpdateUnsubscriber) {
      this.stepUpdateUnsubscriber();
    }

    if (this.selectionUpdateUnsubscriber) {
      this.selectionUpdateUnsubscriber();
    }
  }

  updateStep (data) {
    if (!data.substep) return;

    this.closest('.js-bundle-selections').querySelectorAll('.js-bundle-selection')
      .forEach(el => {
        if (+el.dataset.selectionStep === data.substep) {
          el.classList.remove('hidden');
          setTimeout(() => el.classList.add('active'));
        } else {
          el.classList.remove('active');
          setTimeout(() => el.classList.add('hidden'))
        }
      })
  }

  validateOptions () {
    const defaultOption1 = this.querySelector('.js-main-variants [name="option1"]:checked').value
    const variants = JSON.parse(this.querySelector('[data-variant-json]').textContent)
    const availableVariants = variants.filter(variant => variant.option1 === defaultOption1)

    for (const elem of this.querySelectorAll('.js-main-variants [name="option2"]')) {
      if (availableVariants.map(v => v.option2).includes(elem.value)) {
        elem.removeAttribute('disabled')
      } else {
        elem.setAttribute('disabled', true)
      }
    }
  }

  handleMainSelection (e) {
    if (!this.classList.contains('active')) return;

    const selectedOptions = []
    this.mainVariantsWrapper.querySelectorAll('[data-variant-input]').forEach(el => {
      var type = el.getAttribute('type');

      if (type === 'radio' || type === 'checkbox') {
        if (el.checked) {
          selectedOptions.push({
            value: el.value,
            name: el.name
          });
        }
      } else {
        selectedOptions.push({
          value: el.value,
          name: el.name
        });
      }
    });

    const selectedOption1 = selectedOptions.find(option => option.name === 'option1')
    const variants = JSON.parse(this.querySelector('[data-variant-json]').textContent)
    const availableVariants = variants.filter(variant => variant.option1 === selectedOption1.value)

    for (const elem of this.querySelectorAll('.js-main-variants [name="option2"]')) {
      if (availableVariants.map(v => v.option2).includes(elem.value)) {
        elem.removeAttribute('disabled')
      } else {
        elem.setAttribute('disabled', true)
      }
    }

    const mainVariant = window.bundles.products.filter(variant => variant.product_id === +this.mainProductId).find(variant => {
      const isMatch = selectedOptions.every(({value, name}) => {
        return variant[name] === value;
      });

      return isMatch;
    });

    if (!!this.filter && !!mainVariant?.option1) {
      this.subVariantsWrappers.forEach(wrapper => {
        wrapper.classList[wrapper.dataset.filterTag === `${this.filter}|${mainVariant?.option1}` ? 'remove' : 'add']('hidden')
      })
    }

    if (!!mainVariant?.option2) {
      console.log(mainVariant)
      this.subVariantsWrappers.forEach(wrapper => {
        console.log(wrapper)
        console.log(wrapper.dataset.filterTag)
        console.log(`${this.filter}|${mainVariant?.option2}`)
        console.log('--------')
        // wrapper.classList[wrapper.dataset.filterTag === `${this.filter}|${mainVariant?.option2}` ? 'remove' : 'add']('hidden')

        wrapper.querySelectorAll('.js-dependent-variant').forEach(el => {
          el.checked = el.dataset.title.trim() === mainVariant?.option2.trim()
        })
      })
    }

    this.mainVariantSelection.value = mainVariant.id
    this.mainVariantId = this.mainVariantSelection?.value;

    this.updateSlideshow()
    this.handlePriceDisplay()
  }

  handleSubVariantSelection (e) {
    const title = e.target.dataset.title

    this.subVariantsWrappers.forEach(wrapper => {
      wrapper.querySelectorAll('.js-dependent-variant').forEach(el => {
        el.checked = el.dataset.title === title
      })
    })

    this.updateSlideshow()
    this.handlePriceDisplay()
  }

  updateSlideshow () {
    let image_alt = ''

    if (!!this.mainVariantId) {
      const mainVariant = window.bundles.products.find(variant => variant.id === +this.mainVariantId)

      if (!!mainVariant) image_alt = mainVariant.image_alt
    }

    const subVariantId = this.querySelector('.js-dependent-variants:not(.hidden)')
      ?.querySelector('.js-dependent-variant:checked')?.value

    if (!!subVariantId) {
      const subVariant = window.bundles.products.find(variant => +variant.id === +subVariantId)
      image_alt = subVariant.image_alt
    }

    const carousels = document.querySelectorAll('media-carousel')

    carousels.forEach(carousel => {
      const targetIndex = Array.from(carousel.querySelectorAll('.product-gallery__media')).findIndex(slide => slide.querySelector('img')?.alt === image_alt)

      if (targetIndex > -1) carousel.select(targetIndex, { animate: false });
    })
  }

  handlePriceDisplay () {
    publish(PUB_SUB_EVENTS.selectionUpdate)
  }

  handleSubmit (e) {
    e.preventDefault()

    const subVariantIds = Array.from(this.querySelectorAll('.js-dependent-variants:not(.hidden)'))
      .map(el => +el.querySelector('.js-dependent-variant:checked')?.value)

    if (!!this.mainVariantId) {
      const mainVariant = window.bundles.products.find(variant => +variant.id === +this.mainVariantId)
      window.bundles.selections = window.bundles.selections.filter(item => item.product_id !== mainVariant.product_id)

      window.bundles.selections = [...window.bundles.selections, {
        ...mainVariant,
        purchase_type: 'bundle',
        substep: this.selectionStep,
        label: this.selectionLabel
      }]

      if (!!this.mainVariantsWrapper.dataset.trimrings) {
        document.querySelectorAll(`[data-trimring-selection*="trimrings:${this.mainVariantsWrapper.dataset.trimrings}|"]`).forEach(el => {
          el.classList[el.dataset.trimringSelection === `trimrings:${this.mainVariantsWrapper.dataset.trimrings}|${mainVariant.option1}` ? 'remove' : 'add']('hidden')
        })
      }
    }

    if (subVariantIds.length > 0) {
      const subVariants = window.bundles.products.filter(variant => subVariantIds.includes(variant.id))
        .filter(variant => variant.add_to_cart);

      const subProducts = Array.from(this.subVariantsWrappers).map(el => +el.dataset.productId)
      window.bundles.selections = window.bundles.selections.filter(item => !subProducts.includes(item.product_id))

      window.bundles.selections = [...window.bundles.selections,
        ...subVariants.map(variant => ({
          ...variant,
          purchase_type: 'bundle',
          substep: this.selectionStep,
          label: this.selectionLabel
        }))
      ]
    }

    publish(PUB_SUB_EVENTS.selectionUpdate)

    if (this.selectionStep < this.stepSize) {
      this.closest('.js-bundle-selections').querySelectorAll('.js-bundle-selection')
        .forEach(el => {
          if (+el.dataset.selectionStep === (this.selectionStep + 1)) {
            el.classList.remove('hidden');
            setTimeout(() => el.classList.add('active'));
          } else {
            el.classList.remove('active');
            setTimeout(() => el.classList.add('hidden'))
          }
        })
    } else {
      publish(PUB_SUB_EVENTS.stepUpdate, { step: 2 })
    }
  }

  handleNav (event) {
    const btn = event.target
    const { step, substep } = btn.dataset

    publish(PUB_SUB_EVENTS.stepUpdate, {
      step: +step,
      substep: +substep
    })
  }

  renderSelections () {
    const selections = window.bundles.selections.filter(item => item.purchase_type === 'bundle' && item.substep < this.selectionStep)
    const selectionGroups = selections.reduce((x, y) => {
      (x[y.label] = x[y.label] || []).push(y);
      return x;
    }, {});

    this.querySelector('.js-bundle-selections').innerHTML = Object.keys(selectionGroups).map(label => {
      const options = selectionGroups[label].map(variant => variant.display_title).join(', ')
      return `
        <div class="product-bundle-item">
          ${label}: ${options}

          <button
            type="button"
            class="link js-nav-btn"
            data-step="1"
            data-substep="${selectionGroups[label][0].substep}"
          >Change</button>
        </div>
      `
    }).join('')

    this.querySelectorAll('.js-nav-btn').forEach(btn => {
      btn.addEventListener('click', this.handleNav.bind(this))
    })
  }
}

customElements.define('lg-bundle-selection', LgBundleSelection)

class LgUpsellCard extends HTMLElement {
  constructor () {
    super();

    this.productId = parseInt(this.dataset.productId)
    this.product = window.bundles.upsells.find(item => item.id === this.productId)

    this.querySelectorAll('.js-upsell-variant').forEach(el => el.addEventListener('input', this.handleVariantSelection.bind(this)))

    this.checkbox = this.querySelector('.js-variant')
    this.checkbox.addEventListener('input', this.handleCheckbox.bind(this))
  }

  handleVariantSelection (event) {
    this.checkbox.value = event.target.value

    const variant = this.product.variants.find(e => e.id === +event.target.value)

    this.querySelector('.js-upsell-image').setAttribute('src', variant.featured_image)
    this.querySelector('.js-sale-price').innerHTML = formatMoney(variant.price, currencyFormat)
    this.querySelector('.js-original-price').innerHTML = formatMoney(variant.compare_at_price, currencyFormat)

    this.querySelector('.js-original-price').classList[!variant.compare_at_price ? 'add' : 'remove']('hidden')

    this.handleCheckbox()
  }

  handleCheckbox () {
    const { checked, value } = this.checkbox

    window.bundles.selections = window.bundles.selections.filter(item => item.product_id !== this.productId)
    const variant = this.product.variants.find(e => e.id === +value)

    if (checked) {
      window.bundles.selections = [{
          ...variant,
          product_id: this.productId,
          product_title: this.product.title,
          label: this.product.title,
          purchase_type: 'upsell'
        },
        ...window.bundles.selections
      ]
    }

    publish(PUB_SUB_EVENTS.selectionUpdate)
  }
}

customElements.define('lg-upsell-card', LgUpsellCard)

class LgBundleReview extends HTMLElement {
  constructor () {
    super();

    this.reviewListEl = this.querySelector('.js-bundle-list')
    this.subtotalEl = this.querySelector('.js-subtotal')
    this.savingsEl = this.querySelector('.js-saving-price')
    this.originalPriceEl = this.querySelector('.js-original-subtotal')
    this.confirmBtn = this.querySelector('.js-confirm')
  }

  connectedCallback () {
    this.confirmBtn.addEventListener('click', this.handleSubmit.bind(this))

    this.selectionUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.selectionUpdate, this.renderReview.bind(this));
    document.addEventListener('click', this.handleCartNotification.bind(this))

    if (!!localStorage.getItem('reloaded')) {
      localStorage.removeItem('reloaded')
      window.location.reload()
    }
  }

  disconnectedCallback () {
    if (this.selectionUpdateUnsubscriber) {
      this.selectionUpdateUnsubscriber();
    }
  }

  initEvent () {
    this.querySelectorAll('.js-nav-btn').forEach(btn => {
      btn.addEventListener('click', this.handleNav.bind(this))
    })
  }

  handleNav (event) {
    const btn = event.target
    const { step, substep } = btn.dataset

    publish(PUB_SUB_EVENTS.stepUpdate, {
      step: +step,
      substep: +substep
    })
  }

  async handleSubmit () {
    const uuid = crypto.randomUUID()
    this.confirmBtn.classList.add('button--subdued')
    this.confirmBtn.setAttribute('disabled', true)

    const props = {}
    const items = window.bundles.selections.map(item => {
      props[item.product_title.replace(/&quot;/g, '"')] = item.title.replace(/&quot;/g, '"')

      return {
        id: item.id,
        quantity: 1,
        properties: {
          _purchase_type: item.purchase_type,
          _bundle_id: uuid,
          _bundle_handle: window.bundles.main_product.handle
        }
      }
    })

    let sectionsToBundle = ["variant-added"];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sections: sectionsToBundle,
        sections_url: `${Shopify.routes.root}variants/${window.bundles.main_product.featured_variant}`,
        items
      })
    })

    const responseJson = await response.json();

    if (response.ok) {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent["sections"] = responseJson["sections"];
      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart: cartContent
        }
      }));
      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent
        }
      }));
    }

    this.confirmBtn.classList.remove('button--subdued')
    this.confirmBtn.removeAttribute('disabled')

    document.dispatchEvent(new CustomEvent('cart:refresh'))
  }

  handleCartNotification (e) {
    if (!e.target.closest('.quick-buy-drawer .button')) return;
    localStorage.setItem('reloaded', 'false')
  }

  renderReview () {
    this.subTotalPrice = window.bundles.selections.map(el => el.price).reduce((a, b) => a + b, 0)
    this.originalPrice = window.bundles.selections.map(el => el.compare_at_price || el.price).reduce((a, b) => a + b, 0)

    this.subtotalEl.innerHTML = formatMoney(this.subTotalPrice, currencyFormat)
    this.originalPriceEl.innerHTML = formatMoney(this.originalPrice, currencyFormat)
    this.savingsEl.innerHTML = formatMoney(this.originalPrice - this.subTotalPrice, currencyFormat)

    this.originalPriceEl.classList[this.originalPrice === this.subTotalPrice ? 'add' : 'remove']('hidden')
    this.subtotalEl.classList[this.originalPrice === this.subTotalPrice ? 'remove' : 'add']('text-on-sale')
    this.querySelector('.js-review-price--saving').classList[this.originalPrice === this.subTotalPrice ? 'add' : 'remove']('hidden')

    const bundles = window.bundles.selections.filter(item => item.purchase_type === 'bundle')
    const groupedBundles = bundles.reduce((x, y) => {
      (x[y.label] = x[y.label] || []).push(y);
      return x;
    }, {});

    const upsells = window.bundles.selections.filter(item => item.purchase_type === 'upsell')

    this.reviewListEl.innerHTML = Object.keys(groupedBundles).map(label => {
      const item = groupedBundles[label][0]
      const displayTitle = [... new Set(groupedBundles[label].map(item => item.display_title))].join(', ')
      return `
      <li class="bundle-review-item" data-label="${label}">
          <div class="bundle-review-item__info">
            <img class="bundle-review-item__image" src="${item.featured_image}"/>

            <p class="bundle-review-item__title">${label}: ${displayTitle.replace(label, '')}</p>
          </div>

          <button
            type="button"
            class="link js-nav-btn"
            data-step="${item.purchase_type === 'bundle' ? '1' : '2'}"
            ${!!item.substep ? `data-substep="${item.substep}"` : ''}
          >Change</button>
        </li>`
    }).join('') + upsells.map(item => {
      return `
        <li class="bundle-review-item" data-label="${item.label}">
          <div class="bundle-review-item__info">
            <img class="bundle-review-item__image" src="${item.featured_image}"/>

            <p class="bundle-review-item__title">${item.label}: ${item.display_title || item.title }</p>
          </div>

          <button
            type="button"
            class="link js-nav-btn"
            data-step="${item.purchase_type === 'bundle' ? '1' : '2'}"
            ${!!item.substep ? `data-substep="${item.substep}"` : ''}
          >Change</button>
        </li>
      `
    }).join('')

    this.initEvent()
  }
}

customElements.define('lg-bundle-review', LgBundleReview)
